import type { Locale, NationalProgram } from '../types';
import { chrome, formatDataDate } from '../i18n';
import { programStatus, programPill } from '../core/programs';
import { icon } from './Icon';

export function ProgramCard(p: NationalProgram, locale: Locale, href: string): string {
  const c = chrome(locale);
  const pc = p.content[locale];
  const status = programStatus(p);
  const pill = programPill(status);
  return `
  <a class="card program-card ${pill}" style="--accent:${p.accent}" href="#/${href}" aria-label="${pc.name}">
    <div class="label">
      <span class="ic" style="background:${p.accent}22;color:${p.accent}">${icon(p.icon, 'icon icon-kpi')}</span>
      <b>${pc.name}</b>
      <span class="pill ${pill}">${c.progStatus[status]}</span>
    </div>
    <div class="program-sub">${pc.subtitle}</div>
    <div class="progress-track" title="${c.delivery} ${p.progress}% · ${c.planned} ${p.planned}%">
      <span class="planned-marker" style="inset-inline-start:${p.planned}%"></span>
      <span class="progress-fill" style="width:${p.progress}%"></span>
    </div>
    <div class="program-stats">
      <span><b>${p.progress}%</b> ${c.delivery}</span>
      <span class="muted">${c.planned} ${p.planned}%</span>
    </div>
    <div class="card-foot">
      <span>${icon('user', 'icon icon-xs')} ${pc.owner.split('—')[0].trim()}</span>
      <span class="muted">${icon('calendar', 'icon icon-xs')} ${formatDataDate(locale, p.due)}</span>
    </div>
  </a>`;
}
